import { render, staticRenderFns } from "./NcExportSetting.vue?vue&type=template&id=3b1dfa50&scoped=true&"
import script from "./NcExportSetting.vue?vue&type=script&lang=js&"
export * from "./NcExportSetting.vue?vue&type=script&lang=js&"
import style0 from "./NcExportSetting.vue?vue&type=style&index=0&id=3b1dfa50&prod&lang=less&scoped=true&"
import style1 from "./NcExportSetting.vue?vue&type=style&index=1&id=3b1dfa50&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1dfa50",
  null
  
)

export default component.exports